import { render, staticRenderFns } from "./KBasicContentIcon.vue?vue&type=template&id=6551cf0a&scoped=true&"
import script from "./KBasicContentIcon.vue?vue&type=script&lang=js&"
export * from "./KBasicContentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6551cf0a",
  null
  
)

export default component.exports